import Vue from 'vue'
import VueRouter from 'vue-router'
// import homePage from '@/views/homePage/index'

Vue.use(VueRouter)

// 解决vue路由重复导航错误
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // {
  //   path: '/',
  //   name: 'homePage',
  //   meta: {
  //     roles: ['*']
  //   },
  //   component: homePage,
  //   children: [
  {
    path: '/',
    redirect: '/homePage'
  },
  {
    path: '/homePage',
    name: 'HomePage',
    component: () => import('@/views/homePage'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('@/views/aboutUs'),
    meta: {
      title: '走进我们'
    },
    children: [
      {
        path: '/aboutUs/company',
        name: 'Company',
        redirect: '/aboutUs',
        meta: {
          title: '公司简介'
        }
      },
      {
        path: '/aboutUs/culture',
        name: 'Culture',
        redirect: '/aboutUs',
        meta: {
          title: '公司文化'
        }
      },
      {
        path: '/aboutUs/development',
        name: 'Development',
        redirect: '/aboutUs',
        meta: {
          title: '公司发展'
        }
      },
      {
        path: '/aboutUs/team',
        name: 'Team',
        redirect: '/aboutUs',
        meta: {
          title: '管理团队'
        }
      },
      {
        path: '/aboutUs/platform',
        name: 'Platform',
        redirect: '/aboutUs',
        meta: {
          title: '职业提升平台'
        }
      },
      {
        path: '/aboutUs/certificate',
        name: 'Certificate',
        redirect: '/aboutUs',
        meta: {
          title: '资质荣誉'
        }
      },
      {
        path: '/aboutUs/technology',
        name: 'Technology',
        redirect: '/aboutUs',
        meta: {
          title: '技术与团队'
        }
      }
    ]
  },
  {
    path: '/aboutUs/team/detail',
    name: 'TeamDetail',
    component: () => import('@/views/aboutUs/team/detail'),
    meta: {
      title: '管理团队详情'
    }
  },
  {
    path: '/serviceCenter/kit',
    name: 'ServiceKit',
    component: () => import('@/views/serviceCenter/kit'),
    meta: {
      title: '服务中心系统集成'
    }
  },
  {
    path: '/serviceCenter/product',
    name: 'ServiceProduct',
    component: () => import('@/views/serviceCenter/kit'),
    meta: {
      title: '服务中心软件开发'
    }
  },
  {
    path: '/serviceCenter/technology',
    name: 'ServiceTechnology',
    component: () => import('@/views/serviceCenter/kit'),
    meta: {
      title: '服务中心运维服务'
    }
  },
  {
    path: '/productCenter/bialene',
    name: 'ProductBialene',
    component: () => import('@/views/productCenter/bialene'),
    meta: {
      title: '产品中心智慧环境'
    }
  },
  {
    path: '/productCenter/bialene/detail',
    name: 'ProductBialenedetail',
    component: () => import('@/views/productCenter/bialenedetail'),
    meta: {
      title: '产品中心智慧环境详情'
    }
  },
  {
    path: '/productCenter/bialene/detailShui',
    name: 'ProductBialenedetailShui',
    component: () => import('@/views/productCenter/bialenedetailShui'),
    meta: {
      title: '产品中心智慧环境详情水环境'
    }
  },
  {
    path: '/productCenter/bialene/detailZhhb',
    name: 'ProductBialenedetailZhhb',
    component: () => import('@/views/productCenter/bialenedetailZhhb'),
    meta: {
      title: '产品中心智慧环境详情智慧环保'
    }
  },
  {
    path: '/productCenter/intermediate',
    name: 'ProductIntermediate',
    component: () => import('@/views/productCenter/bialene'),
    meta: {
      title: '产品中心智慧化工园区'
    }
  },
  {
    path: '/productCenter/intermediate/detail',
    name: 'ProductIntermediatedetail',
    component: () => import('@/views/productCenter/Intermediatedetail'),
    meta: {
      title: '产品中心智慧化工园区详情'
    }
  },
  {
    path: '/productCenter/sys',
    name: 'ProductSys',
    component: () => import('@/views/productCenter/bialene'),
    meta: {
      title: '产品中心智慧实验室'
    }
  },
  {
    path: '/productCenter/sys/detail',
    name: 'ProductSys',
    component: () => import('@/views/productCenter/sysdetail'),
    meta: {
      title: '产品中心智慧实验室详情'
    }
  },
  {
    path: '/productCenter/industrial',
    name: 'ProductIndustrial',
    component: () => import('@/views/productCenter/bialene'),
    meta: {
      title: '产品中心智慧工业'
    }
  },
  {
    path: '/productCenter/industrial/detail',
    name: 'ProductIndustrialDetail',
    component: () => import('@/views/productCenter/industrialdetail'),
    meta: {
      title: '产品中心智慧工业详情'
    }
  },
  {
    path: '/newsCenter/news',
    name: 'NewsCenternews',
    component: () => import('@/views/newsCenter/news'),
    meta: {
      title: '新闻中心公司新闻'
    }
  },
  {
    path: '/newsCenter/news/detail',
    name: 'NewsNewsdetail',
    component: () => import('@/views/newsCenter/Newsdetail'),
    meta: {
      title: '新闻中心公司新闻详情'
    }
  },
  {
    path: '/newsCenter/life',
    name: 'NewsCenterlife',
    component: () => import('@/views/newsCenter/news'),
    meta: {
      title: '新闻中心文化生活'
    }
  },
  {
    path: '/newsCenter/life/detail',
    name: 'NewsLifedetail',
    component: () => import('@/views/newsCenter/Lifedetail'),
    meta: {
      title: '新闻中心文化生活详情'
    }
  },
  {
    path: '/joinUs',
    name: 'JoinUs',
    component: () => import('@/views/joinUs'),
    meta: {
      title: '加入我们'
    }
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: () => import('@/views/contactUs'),
    meta: {
      title: '联系我们'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
